<nav
  class="card navs fixed top-0 left-0 w-full z-50 bg-white cursor-pointer dark:bg-[#27272A]"
>
  <div class="flex items-center justify-between gap-2 w-full">
    <!--& logo  -->
    <img
      src="assets/logo.png"
      alt="App Logo"
      class="h-20 w-auto cursor-pointer"
    />

    <div class="flex-col hidden sm:flex">
      <p (click)="showDialog()">Deliver to</p>

      <app-address
        [visible]="visiblee"
        (close)="hideDialog()"
        (addressSelected)="onAddressChange($event)"
      >
      </app-address>
      <p
        class="flex items-center gap-2 text-[var(--navbar-light-coler)] dark:text-[var(--navbar-dark-coler)]"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.9748 7.75296C14.8262 6.04099 14.0222 4.45256 12.7306 3.31907C11.439 2.18558 9.75968 1.59459 8.0429 1.66941C6.32612 1.74423 4.70454 2.47908 3.51649 3.72064C2.32843 4.96219 1.66568 6.61455 1.6665 8.33296C1.6665 12.2413 5.73901 16.3013 7.51817 17.8896M17.8148 13.8546C18.1468 13.5227 18.3333 13.0724 18.3333 12.603C18.3333 12.1335 18.1468 11.6833 17.8148 11.3513C17.4829 11.0193 17.0326 10.8328 16.5632 10.8328C16.0937 10.8328 15.6435 11.0193 15.3115 11.3513L11.9698 14.6946C11.7717 14.8926 11.6267 15.1374 11.5482 15.4063L10.8507 17.798C10.8298 17.8697 10.8285 17.9457 10.847 18.018C10.8656 18.0904 10.9032 18.1564 10.956 18.2093C11.0089 18.2621 11.0749 18.2997 11.1473 18.3183C11.2196 18.3368 11.2956 18.3355 11.3673 18.3146L13.759 17.6171C14.0279 17.5386 14.2727 17.3936 14.4707 17.1955L17.8148 13.8546ZM10.8332 8.33296C10.8332 9.71367 9.71388 10.833 8.33317 10.833C6.95246 10.833 5.83317 9.71367 5.83317 8.33296C5.83317 6.95225 6.95246 5.83296 8.33317 5.83296C9.71388 5.83296 10.8332 6.95225 10.8332 8.33296Z"
            stroke="currentColor"
            stroke-width="1.125"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        {{ selectedCity ? selectedCity : city }}
      </p>
      @if (selectedCity) {
      <button
        class="text-xs text-[var(--navbar-light-coler)] dark:text-[var(--navbar-dark-coler)] mt-1"
        (click)="resetCity()"
      >
        <i class="fa-solid fa-rotate-left"></i>
        Reset location
      </button>
      }
    </div>

    <!--& borgurLinks  -->

    <div class="card flex justify-start sm:hidden">
      <p-drawer #drawerRef [(visible)]="visible">
        <ng-template #headless>
          <div class="flex flex-col h-full">
            <div
              class="flex items-center justify-between px-6 pt-4 shrink-0"
            ></div>
            <div class="flex justify-between items-center px-6">
              <img
                routerLink="/home"
                src="assets/logo.png"
                alt="App Logo"
                class="h-20 w-auto cursor-pointer"
              />
              <div class="flex gap-2">
             <div
          class="relative"
          [class.cursor-pointer]="isLoggedIn"
          [class.opacity-50]="!isLoggedIn"
          (click)="isLoggedIn ? goToWishlist() : onNotLoggedIn()"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 14C20.49 12.54 22 10.79 22 8.5C22 7.04131 21.4205 5.64236 20.3891 4.61091C19.3576 3.57946 17.9587 3 16.5 3C14.74 3 13.5 3.5 12 5C10.5 3.5 9.26 3 7.5 3C6.04131 3 4.64236 3.57946 3.61091 4.61091C2.57946 5.64236 2 7.04131 2 8.5C2 10.8 3.5 12.55 5 14L12 21L19 14Z"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span
            class="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] font-semibold rounded-full w-4 h-4 flex items-center justify-center"
            >{{ (wishlistIds$ | async)?.length || 0 }}</span
          >
        </div>
                <div
                  class="relative"
                  [class.cursor-pointer]="isLoggedIn"
                  [class.opacity-50]="!isLoggedIn"
                  (click)="isLoggedIn ? goToCart() : cartonNotLoggedIn()"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.0498 2.0498H4.0498L6.7098 14.4698C6.80738 14.9247 7.06048 15.3313 7.42552 15.6197C7.79056 15.908 8.24471 16.0602 8.7098 16.0498H18.4898C18.945 16.0491 19.3863 15.8931 19.7408 15.6076C20.0954 15.3222 20.3419 14.9243 20.4398 14.4798L22.0898 7.0498H5.1198M8.9998 20.9998C8.9998 21.5521 8.55209 21.9998 7.9998 21.9998C7.44752 21.9998 6.9998 21.5521 6.9998 20.9998C6.9998 20.4475 7.44752 19.9998 7.9998 19.9998C8.55209 19.9998 8.9998 20.4475 8.9998 20.9998ZM19.9998 20.9998C19.9998 21.5521 19.5521 21.9998 18.9998 21.9998C18.4475 21.9998 17.9998 21.5521 17.9998 20.9998C17.9998 20.4475 18.4475 19.9998 18.9998 19.9998C19.5521 19.9998 19.9998 20.4475 19.9998 20.9998Z"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span
                    class="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] font-semibold rounded-full w-4 h-4 flex items-center justify-center"
                    >{{ (cartCount$ | async) || 0 }}</span
                  >
                </div>
                <i
                  class="pi"
                  [ngClass]="(darkMode$ | async) ? 'pi-sun' : 'pi-moon'"
                  tabindex="0"
                  (click)="toggleTheme()"
                  (keydown.enter)="toggleTheme()"
                  (keydown.space)="toggleTheme()"
                ></i>
              </div>
            </div>
            <div class="overflow-y-auto">
              <ul class="list-none p-4 m-0">
                <li>
                  @for (item of items; track $index) {
                  <a
                    pRipple
                    class="flex items-center cursor-pointer p-4 rounded-border text-surface-700 !dark:text-surface-100 hover:bg-surface-100 dark:hover:bg-surface-700 duration-150 transition-colors relative group"
                    [routerLink]="item.routerLink"
                    routerLinkActive="active-link"
                    [routerLinkActiveOptions]="{ exact: true }"
                  >
                    @if(item?.template()){
                    <div
                      class="group-[.active-link]:text-[#FFC2D0] transition-colors duration-300"
                      [innerHTML]="item.template?.()"
                    ></div>
                    }
                    <span
                      class="font-medium mx-2 group-[.active-link]:text-[#FFC2D0]"
                    >
                      {{ item.label }}
                    </span>
                    <span
                      class="absolute bottom-0 left-0 h-[2px] w-0 transition-all duration-300 bg-[#FFC2D0] group-hover:w-full group-[.active-link]:w-full dark:bg-gray-200"
                    >
                    </span>
                  </a>
                  }
                  <ul class="list-none p-0 m-0 overflow-hidden">
                    <li>
                      @for (item of logins?.[0]?.items?.[0]?.[0]?.items ?? [];
                      track $index) {
               
                        @if (item.label !=='MY_ADDRESSES') {
                                 <a
                        pRipple
                        class="flex items-center cursor-pointer p-4 relative rounded-border text-surface-700 dark:text-surface-100 iconscolor hover:bg-surface-100 dark:hover:bg-surface-700 duration-150 transition-colors p-ripple group"
                        [routerLink]="item.routerLink"
                        routerLinkActive="active-link"
                        [routerLinkActiveOptions]="{ exact: true }"
                      >
                        @if(item?.['template']?.()){
                        <div [innerHTML]="item['template']?.()"></div>
                        }
                             <span
                          class="font-medium mx-2 group-[.active-link]:text-[#FFC2D0]"
                        >
                          {{ item.label }}
                        </span>

                        <span
                          class="absolute bottom-0 left-0 h-[2px] w-0 transition-all duration-300 bg-[#FFC2D0] group-hover:w-full group-[.active-link]:w-full dark:bg-gray-200"
                        >
                        </span>
                         </a>
                        }
                     
                     

                      }
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div class="mt-auto flex border-t-2">
              <hr class="mb-4  border-t border-0 border-surface" />
              @if(firstName===null){
              <div class="flex items-center justify-center">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.8332 17.5V15.8333C15.8332 14.9493 15.482 14.1014 14.8569 13.4763C14.2317 12.8512 13.3839 12.5 12.4998 12.5H7.49984C6.61578 12.5 5.76794 12.8512 5.14281 13.4763C4.51769 14.1014 4.1665 14.9493 4.1665 15.8333V17.5M13.3332 5.83333C13.3332 7.67428 11.8408 9.16667 9.99984 9.16667C8.15889 9.16667 6.6665 7.67428 6.6665 5.83333C6.6665 3.99238 8.15889 2.5 9.99984 2.5C11.8408 2.5 13.3332 3.99238 13.3332 5.83333Z"
                    stroke="currentColor"
                    stroke-width="1.45833"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span
                  routerLink="/login"
                  class="dark:text-gray-200 cursor-pointer"
                  >login</span
                >
              </div>
              }@else {
              <a
                pRipple
                class="m-4 flex items-center cursor-pointer py-4 gap-2 rounded-border text-surface-700 dark:text-surface-100 hover:bg-surface-100 dark:hover:bg-surface-700 duration-150 transition-colors p-ripple"
              >
                <img
                  [src]="photo || 'assets/default-avatar.svg'"
                  alt="Profile avatar"
                  class="h-10 w-10 rounded-full object-cover "
                />
                <span class="font-bold">{{ firstName }}</span>
              </a>
              }
                   <p
        class="flex items-center gap-2 text-[var(--navbar-light-coler)] dark:text-[var(--navbar-dark-coler)]"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.9748 7.75296C14.8262 6.04099 14.0222 4.45256 12.7306 3.31907C11.439 2.18558 9.75968 1.59459 8.0429 1.66941C6.32612 1.74423 4.70454 2.47908 3.51649 3.72064C2.32843 4.96219 1.66568 6.61455 1.6665 8.33296C1.6665 12.2413 5.73901 16.3013 7.51817 17.8896M17.8148 13.8546C18.1468 13.5227 18.3333 13.0724 18.3333 12.603C18.3333 12.1335 18.1468 11.6833 17.8148 11.3513C17.4829 11.0193 17.0326 10.8328 16.5632 10.8328C16.0937 10.8328 15.6435 11.0193 15.3115 11.3513L11.9698 14.6946C11.7717 14.8926 11.6267 15.1374 11.5482 15.4063L10.8507 17.798C10.8298 17.8697 10.8285 17.9457 10.847 18.018C10.8656 18.0904 10.9032 18.1564 10.956 18.2093C11.0089 18.2621 11.0749 18.2997 11.1473 18.3183C11.2196 18.3368 11.2956 18.3355 11.3673 18.3146L13.759 17.6171C14.0279 17.5386 14.2727 17.3936 14.4707 17.1955L17.8148 13.8546ZM10.8332 8.33296C10.8332 9.71367 9.71388 10.833 8.33317 10.833C6.95246 10.833 5.83317 9.71367 5.83317 8.33296C5.83317 6.95225 6.95246 5.83296 8.33317 5.83296C9.71388 5.83296 10.8332 6.95225 10.8332 8.33296Z"
            stroke="currentColor"
            stroke-width="1.125"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        {{ selectedCity ? selectedCity : city }}
      </p>
      @if (selectedCity) {
      <button
        class="text-xs text-[var(--navbar-light-coler)] dark:text-[var(--navbar-dark-coler)] mt-1"
        (click)="resetCity()"
      >
        <i class="fa-solid fa-rotate-left"></i>
        Reset location
      </button>
      }
            </div>
          </div>
        </ng-template>
      </p-drawer>
      <p-button
        class="borgerPtn"
        (click)="visible = true"
        icon="pi pi-bars"
      ></p-button>
    </div>
    <!--& sInput  -->
    <div class="relative flex-1 pe-2 md:pe-0">
      <input
        type="text"
        pInputText
        [placeholder]="'SEARCH_GIFT' | translate"
        class="peer w-full border border-gray-300 rounded-md transition-all duration-300 hover:[border-color:var(--hover-coler)] focus:[border-color:var(--hover-coler)] hover:[--tw-placeholder-color:var(--hover-coler)] focus:[--tw-placeholder-color:var(--hover-coler)]"
      />
      <span
        class="absolute left-2 top-1/2 transform -translate-y-1/2 pointer-events-none"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.75 15.75L12.495 12.495M14.25 8.25C14.25 11.5637 11.5637 14.25 8.25 14.25C4.93629 14.25 2.25 11.5637 2.25 8.25C2.25 4.93629 4.93629 2.25 8.25 2.25C11.5637 2.25 14.25 4.93629 14.25 8.25Z"
            stroke="#A1A1AA"
            stroke-width="1.25"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </div>
    <!--& fristName  -->
    <div class="items-center justify-center gap-1 mx-8 hidden sm:flex">
      <div
        class="icons relative after:content-[''] after:w-[2px] after:h-10 after:bg-gray-400 after:inline-block after:mx-3 last:after:content-none flex items-center dark:text-gray-200 gap-1"
      >
        @if(firstName===null){
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.8332 17.5V15.8333C15.8332 14.9493 15.482 14.1014 14.8569 13.4763C14.2317 12.8512 13.3839 12.5 12.4998 12.5H7.49984C6.61578 12.5 5.76794 12.8512 5.14281 13.4763C4.51769 14.1014 4.1665 14.9493 4.1665 15.8333V17.5M13.3332 5.83333C13.3332 7.67428 11.8408 9.16667 9.99984 9.16667C8.15889 9.16667 6.6665 7.67428 6.6665 5.83333C6.6665 3.99238 8.15889 2.5 9.99984 2.5C11.8408 2.5 13.3332 3.99238 13.3332 5.83333Z"
            stroke="currentColor"
            stroke-width="1.45833"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span routerLink="/login" class="dark:text-gray-200 cursor-pointer"
          >login</span
        >
        }@else {
        <div class="flex items-center gap-2">
          <a
            class="flex items-center gap-2"
            title="Profile"
            aria-label="Go to profile"
          >
            <img
              [src]="photo || 'assets/default-avatar.svg'"
              alt="Profile avatar"
              role="img"
              loading="lazy"
              class="h-8 w-8 rounded-full object-cover"
            />
            <div style="display: flex; flex-direction: column">
              <p class="text-sm text-gray-500 font-medium">Hello</p>
              <p-megamenu [model]="logins" breakpoint="0"></p-megamenu>
            </div>
          </a>
        </div>
        }
      </div>
      <!--& icons  -->
      <div
        class="icons relative flex items-center after:content-[''] after:w-[2px] after:h-10 after:bg-gray-400 after:inline-block after:mx-3 last:after:content-none gap-4 dark:text-gray-200"
      >
        <div
          class="relative"
          [class.cursor-pointer]="isLoggedIn"
          [class.opacity-50]="!isLoggedIn"
          (click)="isLoggedIn ? goToWishlist() : onNotLoggedIn()"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 14C20.49 12.54 22 10.79 22 8.5C22 7.04131 21.4205 5.64236 20.3891 4.61091C19.3576 3.57946 17.9587 3 16.5 3C14.74 3 13.5 3.5 12 5C10.5 3.5 9.26 3 7.5 3C6.04131 3 4.64236 3.57946 3.61091 4.61091C2.57946 5.64236 2 7.04131 2 8.5C2 10.8 3.5 12.55 5 14L12 21L19 14Z"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span
            class="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] font-semibold rounded-full w-4 h-4 flex items-center justify-center"
            >{{ (wishlistIds$ | async)?.length || 0 }}</span
          >
        </div>

        <div
          class="relative"
          [class.curosor-pointer]="isLoggedIn"
          [class.opacity-50]="!isLoggedIn"
          (click)="isLoggedIn ? goToCart() : cartonNotLoggedIn()"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.0498 2.0498H4.0498L6.7098 14.4698C6.80738 14.9247 7.06048 15.3313 7.42552 15.6197C7.79056 15.908 8.24471 16.0602 8.7098 16.0498H18.4898C18.945 16.0491 19.3863 15.8931 19.7408 15.6076C20.0954 15.3222 20.3419 14.9243 20.4398 14.4798L22.0898 7.0498H5.1198M8.9998 20.9998C8.9998 21.5521 8.55209 21.9998 7.9998 21.9998C7.44752 21.9998 6.9998 21.5521 6.9998 20.9998C6.9998 20.4475 7.44752 19.9998 7.9998 19.9998C8.55209 19.9998 8.9998 20.4475 8.9998 20.9998ZM19.9998 20.9998C19.9998 21.5521 19.5521 21.9998 18.9998 21.9998C18.4475 21.9998 17.9998 21.5521 17.9998 20.9998C17.9998 20.4475 18.4475 19.9998 18.9998 19.9998C19.5521 19.9998 19.9998 20.4475 19.9998 20.9998Z"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span
            class="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] font-semibold rounded-full w-4 h-4 flex items-center justify-center"
            >{{ (cartCount$ | async) || 0 }}</span
          >
        </div>

        <div class="relative">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.2678 21C10.4433 21.304 10.6958 21.5565 10.9998 21.732C11.3038 21.9075 11.6487 21.9999 11.9998 21.9999C12.3508 21.9999 12.6957 21.9075 12.9997 21.732C13.3037 21.5565 13.5562 21.304 13.7318 21M3.26176 15.326C3.13112 15.4692 3.04491 15.6472 3.01361 15.8385C2.98231 16.0298 3.00728 16.226 3.08546 16.4034C3.16365 16.5807 3.29169 16.7316 3.45401 16.8375C3.61633 16.9434 3.80594 16.9999 3.99976 17H19.9998C20.1936 17.0001 20.3832 16.9438 20.5456 16.8381C20.708 16.7324 20.8363 16.5817 20.9146 16.4045C20.993 16.2273 21.0182 16.0311 20.9872 15.8398C20.9561 15.6485 20.8702 15.4703 20.7398 15.327C19.4098 13.956 17.9998 12.499 17.9998 8C17.9998 6.4087 17.3676 4.88258 16.2424 3.75736C15.1172 2.63214 13.5911 2 11.9998 2C10.4085 2 8.88234 2.63214 7.75712 3.75736C6.6319 4.88258 5.99976 6.4087 5.99976 8C5.99976 12.499 4.58876 13.956 3.26176 15.326Z"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span
            class="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] font-semibold rounded-full w-4 h-4 flex items-center justify-center"
            >1</span
          >
        </div>
        <div class="relative">
          <i
            class="pi"
            [ngClass]="(darkMode$ | async) ? 'pi-sun' : 'pi-moon'"
            tabindex="0"
            (click)="toggleTheme()"
            (keydown.enter)="toggleTheme()"
            (keydown.space)="toggleTheme()"
          ></i>
        </div>
      </div>
      <!--& language  -->
      <div
        class="icons flex items-center justify-center gap-1 dark:text-gray-200"
      >
        <button (click)="switchLanguage()">{{ lang }}</button>
      </div>
    </div>
  </div>

  <div
    class="links hidden sm:flex justify-center items-center gap-x-6 text-[#FAFAFA] bg-[--navbar-light-coler] dark:bg-[var(--navbar-dark-coler)] dark:text-[#27272A]"
  >
    @for (item of items; track $index) {

    <div
      class="group relative flex items-center cursor-pointer"
      [routerLink]="item.routerLink"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <div
        class="sm:py-4 transition-colors text-white group-hover:text-[#FFC2D0] group-[.active-link]:text-[#FFC2D0] dark:text-[#27272A] dark:group-hover:text-black dark:group-[.active-link]:text-black"
        [innerHTML]="item.template?.()"
      ></div>

      <span
        class="hidden lg:inline-block p-2 transition-colors group-hover:text-[#FFC2D0] group-[.active-link]:text-[#FFC2D0] dark:text-[#27272A] dark:group-hover:text-black dark:group-[.active-link]:text-black"
      >
        {{ item.label | translate }}
      </span>

      <span
        class="absolute bottom-1 left-0 h-[2px] w-0 transition-all duration-300 bg-[#FFC2D0] group-hover:w-full group-[.active-link]:w-full dark:bg-black"
      >
      </span>
    </div>

    }
  </div>
</nav>
